import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';

const CHILD_ROUTES = {
  list: 'data-index.type.list.index',
};

export default class IndexRoute extends Route {
  // Normally with an explicit index route that contains a redirect, it takes
  // you to the intended beginning of that section. When we have a tabbed page,
  // like Broadcasts, where each tab is a route, however, clicking the main nav
  // will redirect to the initial tab again, rather than staying put. It's a
  // consequence of our routing pattern being used with tabs.
  redirect(_: unknown, transition: Transition) {
    if (transition.from && Object.values(CHILD_ROUTES).includes(transition.from.name)) {
      transition.abort();

      return;
    }

    this.router.transitionTo('data-index.type', 'attributes');
  }
}
